import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
	<div className='not-found' style={{ padding: '3rem 1.5rem', textAlign: 'center' }}>
		<h1>Siden finnes ikke</h1>
		<p>Siden du leter etter eksisterer ikke, eller du har ikke tilgang.</p>
		<p>
			<Link to='/'>Gå til forsiden</Link>
		</p>
	</div>
);

export default NotFound;
